import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { AccountData } from 'src/stores/useVelocityAccountsStore';
import { useUpdateCurrentSubaccount } from '../velocityActions/user/useUpdateCurrentSubaccount';
import { useHotkeyCombo, useHotkeyHoldingCombo } from './useHotkeyCombo';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import { useShallow } from 'zustand/react/shallow';

export const useSubAccountNumberSwitchHotkeys = (
	subAccountsOrdered: AccountData[],
	subAccountIndex: number
) => {
	const { updateCurrentSubaccount } = useUpdateCurrentSubaccount();
	const currentAuthority = useVelocityStore(
		(state) => state.wallet.current?.adapter?.publicKey
	);

	useHotkeyCombo(['d', (subAccountIndex + 1).toString()], () => {
		if (currentAuthority && subAccountsOrdered?.length > subAccountIndex) {
			updateCurrentSubaccount(
				subAccountsOrdered[subAccountIndex].userId,
				currentAuthority
			);
		}
	});
};

export const useOpenSubaccountSelectPanelHotkey = (
	subAccountsOrdered: AccountData[]
) => {
	// Array selector needs shallow equality: a fresh array every call defeats
	// render bailout for the whole `useAppSetup` fiber this runs on.
	const [setStore, setSelectedAccountIndex] = useDrawersStore(
		useShallow((s) => [s.set, s.accountHotkeySelection.selectedAccountIndex])
	);
	const { updateCurrentSubaccount } = useUpdateCurrentSubaccount();
	const currentAuthority = useVelocityStore(
		(state) => state.wallet.current?.adapter?.publicKey
	);

	useHotkeyHoldingCombo(
		['d', 'tab'],
		'd',
		() => {
			setStore((s) => {
				s.accountHotkeySelection.show = true;
			});
		},
		() => {
			setStore((s) => {
				s.accountHotkeySelection.show = false;
			});
			const newUserId = subAccountsOrdered[setSelectedAccountIndex]?.userId;
			if (newUserId !== undefined && currentAuthority) {
				updateCurrentSubaccount(newUserId, currentAuthority);
			}
		},
		[
			{
				keys: ['tab'],
				callback: () => {
					setStore((s) => {
						const nextIndex = s.accountHotkeySelection.selectedAccountIndex + 1;
						s.accountHotkeySelection.selectedAccountIndex =
							nextIndex >= subAccountsOrdered.length ? 0 : nextIndex;
					});
				},
			},
			{
				keys: ['shift', 'tab'],
				callback: () => {
					setStore((s) => {
						const prevIndex = s.accountHotkeySelection.selectedAccountIndex - 1;
						s.accountHotkeySelection.selectedAccountIndex =
							prevIndex < 0 ? subAccountsOrdered.length - 1 : prevIndex;
					});
				},
			},
		]
	);
};
